import React, { useState } from "react";
import { Button, Table, Flex, FlexItem, Icon } from "orcs-design-system";
import { useQuery } from "@apollo/client";
import FancyCard, { FancyCardBody } from "src/components/FancyCard/FancyCard";
import { getApiKeys } from "src/queries/apiKeys.graphql";
import columnConfig from "./columnConfig";
import CreateModal from "./createModal";
import SecretRevealModal from "./secretRevealModal";
import RotateSecretModal from "./rotateSecretModal";
import DeleteSecretModal from "./deleteSecretModal";

const APIKeyManager = () => {
  const columns = columnConfig();
  const { data, refetch } = useQuery(getApiKeys);
  const [rotateSecretVisible, setRotateSecretVisible] = useState(false);
  const [deleteSecretVisible, setDeleteSecretVisible] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [secretVisible, setSecretVisible] = useState(false);

  let apiKeys = data?.apiKeys || [];

  apiKeys = apiKeys.map((key) => ({
    ...key,
    clientMetadata: {
      ...key.clientMetadata,
      workspaces: key.clientMetadata.workspaces.join(", "),
      readScopes: key.clientMetadata.readScopes.join(", "),
      writeScopes: key.clientMetadata.writeScopes.join(", "),
      expiryDate: key.clientMetadata.expiryDate,
    },
    actions: (
      <Flex gap="s">
        <Button
          small
          onClick={() => {
            setRotateSecretVisible(true);
            setClientId(key.clientId);
          }}
        >
          Rotate secret
        </Button>
        <Button
          variant="danger"
          small
          onClick={() => {
            setDeleteSecretVisible(true);
            setClientId(key.clientId);
          }}
        >
          Delete
        </Button>
      </Flex>
    ),
  }));

  const handleOnButtonClick = () => {
    setCreateModalVisible(true);
  };

  const onHideSecretRevealModal = () => {
    setSecretVisible(false);
    setClientId(null);
    setClientSecret(null);
    refetch();
  };
  return (
    <Flex
      data-testid="api-key-manager"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      width="100%"
      height="100%"
      overflow="hidden"
      style={{ height: "100%" }}
    >
      <FlexItem width="100%" flex="0 0 auto">
        <Flex justifyContent="right">
          <Button mb="s" iconLeft onClick={handleOnButtonClick}>
            <Icon icon={["fas", "plus"]} />
            Create API Key
          </Button>
        </Flex>
      </FlexItem>

      <FlexItem
        width="100%"
        height="100%"
        flex="1 1 auto"
        overflow="hidden"
        minHeight="0"
      >
        <FancyCard height="100%">
          <FancyCardBody>
            <Table
              data={apiKeys}
              columns={columns}
              enableTopToolbar={false}
              enablePagination={false}
              layoutMode="grid"
              enableExpandAll={false}
              enableColumnPinning={true}
              initialState={{
                columnVisibility: {
                  "mrt-row-expand": false,
                },
                columnPinning: { right: ["actions"] },
              }}
            />
          </FancyCardBody>
        </FancyCard>
      </FlexItem>
      <CreateModal
        visible={createModalVisible}
        onHideModal={() => {
          setCreateModalVisible(false);
        }}
        onCreateCredentials={(result) => {
          setClientId(result.clientId);
          setClientSecret(result.clientSecret);
          setSecretVisible(true);
          setCreateModalVisible(false);
        }}
      />
      <SecretRevealModal
        visible={secretVisible}
        clientId={clientId}
        clientSecret={clientSecret}
        onHideModal={() => {
          onHideSecretRevealModal();
        }}
      />
      <RotateSecretModal
        visible={rotateSecretVisible}
        clientId={clientId}
        onHideModal={() => {
          setRotateSecretVisible(false);
        }}
        onRotateSecret={(result) => {
          setClientId(result.clientId);
          setClientSecret(result.clientSecret);
          setSecretVisible(true);
          setRotateSecretVisible(false);
        }}
      />
      <DeleteSecretModal
        visible={deleteSecretVisible}
        clientId={clientId}
        onHideModal={() => {
          setDeleteSecretVisible(false);
        }}
        refetch={refetch}
      />
    </Flex>
  );
};

APIKeyManager.propTypes = {};

export default APIKeyManager;
